// extracted by mini-css-extract-plugin
export var copyableItem = "_47-0";
export var underlined = "_47-1";